import { useEffect, useMemo, useState } from "react";
import { IntakePetStoreContextWrapper } from "@customer/contexts";
import { IntakePetStore, IntakeStore } from "@customer/stores";

export const useCreateIntakePetStore = (intakeStore: IntakeStore, options?: { shouldSetContext?: boolean }) => {
    const [shouldSetContext, setShouldSetContext] = useState<boolean>(Boolean(options?.shouldSetContext));

    useEffect(() => {
        if (options)
            setShouldSetContext(Boolean(options.shouldSetContext));
    }, [options])

    const [intakePetStore] = useMemo(() => {
        const store = new IntakePetStore(intakeStore);
        if (shouldSetContext)
            IntakePetStoreContextWrapper.set(store);
        return [store];
    }, [intakeStore, shouldSetContext]);

    return intakePetStore;
}
